// extracted by mini-css-extract-plugin
export default {"tabs":"AdvertisingResearchPage_tabs__88hqi"};